export class ColumnDefinitionModel {

    constructor(
        public Position: number,
        public DisplayName: string,
        public ColumnName: string,
        public IsVisible: boolean,
        public CanHide: boolean = true,
        public CanSort: boolean = true,
        public CssClass: string = null,
        public IsHtmlContent: boolean = false,
        public Pipe: PipeDefinitionModel = null,
        public ExportPipe: PipeDefinitionModel = null,
        public ToolTip: boolean | null = false) {
    }
}

export class PipeDefinitionModel {

    constructor(
        public PipeName: string,
        public PipeArgs: string | object = null,
        public ParamExtractor: (data: any) => string = () => '') {
    }
}
